<template>
  <form
    class="credit-note"
    @submit.prevent="onSubmit"
  >
    <div class="container">
      <div class="columns is-multiline">
        <div class="column is-6">
          <Receiver
            :is-loading="loading"
            :disabled="disabled"
            @customer="onSelectCustomer"
          />
        </div>

        <div class="column is-6">
          <VoucherDetails
            ref="voucherDetailsComponent"
            :is-loading="loading"
            :disabled="disabled"
            @customer="onSelectCustomer"
          />
        </div>

        <div class="column is-12">
          <Concepts
            :is-loading="loading"
            :disabled="disabled"
            @customer="onSelectCustomer"
          />
        </div>

        <div class="column is-12">
          <CfdisRelatedReplacement
            replacement-type="replacementCreditNote"
            :disabled="disabled"
          />
        </div>

        <div class="column is-12 action-buttons">
          <div class="field is-grouped">
            <p class="control">
              <button
                class="button is-success"
                type="submit"
                :class="{ 'is-loading': loading }"
                :disabled="loading || disabled"
                @click="setStamp(true)"
              >
                Guardar y Timbrar
              </button>
            </p>

            <p class="control">
              <RouterLink
                class="button is-danger"
                :class="{ 'is-loading': loading }"
                :disabled="loading"
                :to="{ name: 'Home' }"
              >
                {{ disabled ? 'Regresar' : 'Cancelar' }}
              </RouterLink>
            </p>
          </div>
        </div>

        <CustomerInvoices
          v-if="customerInvoicesActive"
          :customer="customer"
        />

        <RouterView />
      </div>
    </div>
  </form>
</template>

<script>
import get from 'lodash/get';
import merge from 'lodash/merge';
import { mapMutations, mapActions } from 'vuex';

export default {
  name: 'CreditNote',
  components: {
    Receiver: () => import(/* webpackChunkName: "invoice-receiver" */ '@/components/Admin/Invoices/NewInvoice/Receiver.vue'),
    VoucherDetails: () => import(/* webpackChunkName: "invoice-voucher-details" */ '@/components/Admin/Invoices/NewInvoice/VoucherDetails.vue'),
    Concepts: () => import(/* webpackChunkName: "invoice-concepts" */ '@/components/Admin/Invoices/NewInvoice/Concepts.vue'),
    CustomerInvoices: () => import(/* webpackChunkName: "customer-invoices" */ '@/components/Admin/Invoices/CustomerInvoices.vue'),
    CfdisRelatedReplacement: () => import(/* webpackChunkName: "cfdis-related-replacement" */ '@/components/Admin/CFDI/CfdisRelatedReplacement.vue'),
  },
  data() {
    return {
      loading: false,
      disabled: false,
      stamp: false,
    };
  },
  computed: {
    customerInvoicesActive() {
      return !!this.$route.query.customer && this.$store.state.customers.rfc;
    },
    customer() {
      const { customer } = this.$route.query;

      return customer ? parseInt(customer, 10) : null;
    },
  },
  async beforeMount() {
    this.setInitialState();

    if (this.$route.params.uuid) {
      this.loading = true;

      const cfdi = await this.$store.dispatch('invoice/getByUuid', this.$route.params.uuid);

      this.disabled = cfdi.stamped;

      this.loading = false;
    } else {
      this.$store.commit(
        'users/setValues',
        { email: '', name: '' },
      );
    }
  },
  mounted() {
    this.$store.commit(
      'invoice/setValues',
      {
        voucherType: 'E',
        voucherSeries: 'E',
      },
    );

    this.$store.commit('invoice/deleteConcept', 1);
  },
  beforeRouteUpdate(to, { name }, next) {
    if (name === 'NewInvoiceCustomerSearcher') {
      this.$refs.voucherDetailsComponent.focusEmail();
    }
    next();
  },
  methods: merge(
    mapMutations({
      setInitialState: 'invoice/setInitialState',
    }),
    mapActions({
      saveInvoice: 'invoice/save',
      updateInvoice: 'invoice/updateByUuid',
    }),
    {
      setStamp(value) {
        this.stamp = value;
      },
      async onSubmit() {
        this.loading = true;

        const { stamp } = this;
        const { haveEfirma, id: companyId } = this.$store.state.company;

        const { uuid } = this.$route.params;

        try {
          let payload = {};

          if (uuid) {
            payload = await this.updateInvoice({ stamp, uuid });
          } else {
            payload = await this.saveInvoice({ stamp });
          }

          const content = stamp ? 'Timbrado exitoso' : 'Guardado correctamente';
          const name = stamp ? 'CreditNoteList' : 'PreInvoiceList';

          this.$store.commit('ui/setValue', {
            accessor: 'catalogs.sku',
            value: [],
          });

          this.loading = false;

          const to = { name };

          if (!haveEfirma && stamp) {
            this.$warning({ message: 'Necesitas cargar tu CSD para emitir la factura' });

            to.name = 'Company';
            to.params = { id: companyId };
            to.query = { stamp: get(payload, '_doc._id', '') };
          } else this.$success({ message: content });

          this.$router.push(to);
        } catch (error) {
          this.$danger({
            message: stamp
              ? error.message
              : 'Ocurrio un error al guardar.',
          });

          this.loading = false;
        }
      },
      onSelectCustomer({ id }) {
        const customerId = parseInt(this.$route.query.customer, 10);

        if (customerId !== id) {
          this.$router.push({ query: { customer: id } });
        }
      },
    },
  ),
};
</script>

<style scoped>
.action-buttons {
  display: flex;
  justify-content: flex-end;
}

@media screen and (min-width: 1088px) {
  .credit-note:not(.concepts) {
    width: calc(100vw - 265px);
  }
}

.container {
  padding: 1rem;
}
</style>
